<template>
  <v-layout row wrap justify-space-between>
    <v-flex xs12 md6 lg5>
      <v-flex xs12>
        <v-text-field
          :label="$t('surveys.create_survey.survey_name')"
          :value="poll.title"
          prepend-icon="title"
          rows="1"
          row-height="24"
          auto-grow
          disabled
        />
      </v-flex>

      <v-list>
        <v-list-tile avatar>
          <v-list-tile-avatar>
            <v-icon class="red--text">date_range</v-icon>
          </v-list-tile-avatar>
          <v-list-tile-content>
            <v-list-tile-title>
              {{ $t('surveys.create_survey.periodicity') }}
            </v-list-tile-title>
            <v-list-tile-sub-title v-if="poll.periodicity">
              {{ poll.periodicity | periodicity }}
            </v-list-tile-sub-title>
            <v-list-tile-sub-title v-else>---</v-list-tile-sub-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile avatar>
          <v-list-tile-avatar>
            <v-icon class="red--text">event</v-icon>
          </v-list-tile-avatar>
          <v-list-tile-content>
            <v-list-tile-title>
              {{ $t('surveys.create_survey.start_date') }}
            </v-list-tile-title>
            <v-list-tile-sub-title v-if="poll.startDate">
              {{ poll.startDate | formatDate }}
            </v-list-tile-sub-title>
            <v-list-tile-sub-title v-else>---</v-list-tile-sub-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile avatar v-if="poll.endDate">
          <v-list-tile-avatar>
            <v-icon class="red--text">event</v-icon>
          </v-list-tile-avatar>
          <v-list-tile-content>
            <v-list-tile-title>
              {{ $t('surveys.create_survey.end_date') }}
            </v-list-tile-title>
            <v-list-tile-sub-title>
              {{ poll.endDate | formatDate }}
            </v-list-tile-sub-title>
          </v-list-tile-content>
        </v-list-tile>

        <v-flex xs12>
          <v-btn
            @click="viewAudiency"
            class="red--text"
            outlined
            flat
            style="text-transform: none"
          >
            <v-icon left>remove_red_eye</v-icon>
            {{ $t('surveys.create_survey.vew_audience_list') }}
          </v-btn>
        </v-flex>
      </v-list>
    </v-flex>

    <v-flex xs12 md4 offset-md2 justify-space-between>
      <v-layout row wrap align-center justify-space-between>
        <v-flex xs12 md12>
          <v-checkbox
            color="primary"
            id="split"
            v-model="poll.publish"
            :label="$t('surveys.create_survey.schedule_survey')"
            :disabled="isEdit && poll.publish == true"
          />
        </v-flex>
        <v-flex xs12 md12>
          <v-checkbox
            color="primary"
            id="required"
            v-model="poll.requiredForEntry"
            :label="$t('surveys.create_survey.required_for_access')"
          />
        </v-flex>
        <v-flex xs12 md12>
          <v-checkbox
            color="primary"
            id="required"
            v-model="poll.notifyByEmail"
            :label="$t('surveys.create_survey.notify_by_mail')"
          />

          <v-text-field
            v-show="poll.notifyByEmail"
            outline
            label="Correo"
            v-model="textBox"
            type="email"
          >
            <template v-slot:append>
              <v-btn icon @click="addChips"
                ><v-icon>control_point</v-icon></v-btn
              >
            </template>
          </v-text-field>
          <template>
            <v-chip
              v-for="(chipText, index) in poll.chipData"
              :key="index"
              @click="deleteChips(index)"
              class="gradiente white--text"
              >{{ chipText }}<v-icon right small>cancel</v-icon></v-chip
            >
          </template>
        </v-flex>
      </v-layout>
      <v-layout row>
        <v-flex xs12 md12>
          <v-btn
            @click="viewQuestions"
            color="error"
            style="text-transform: none"
          >
            {{ $t('surveys.create_survey.view_questions') }}
          </v-btn>
        </v-flex>
      </v-layout>
    </v-flex>
    <AudiencyModal
      v-model="modals.showAudiency"
      :payment="poll"
      :institutional="poll.institutional"
      @onClosed="onCancel"
    />
  </v-layout>
</template>

<script>
import AudiencyModal from '../../Modals/DetailAudiencyPoll.vue'
export default {
  components: {
    AudiencyModal,
  },
  props: ['poll', 'isEdit'],
  data: () => ({
    modals: {
      showAudiency: false,
    },
    textBox: '',
  }),
  methods: {
    viewAudiency() {
      this.modals.showAudiency = true
    },
    onCancel() {
      this.modals.showAudiency = false
      this.$emit('closedPopup')
    },
    viewQuestions() {
      this.$emit('viewQuestions')
    },
    addChips() {
      const emailRegex =
        /^[-\w.%+]{1,64}@(?:[A-Z0-9-]{1,63}\.){1,125}[A-Z]{2,63}$/i
      this.textBox = this.textBox.toLowerCase()
      if (emailRegex.test(this.textBox)) {
        this.poll.chipData.push(this.textBox)
        this.poll.theEmailsToNotify = this.poll.chipData
        this.textBox = ''
      } else {
      }
    },
    deleteChips(id) {
      this.poll.chipData.splice(id, 1)
      this.poll.theEmailsToNotify = this.poll.chipData
      this.$forceUpdate()
    },
    handleKeyDown(e) {
      //method to handle the keypress
      if (e.code === 'Enter') {
        this.addChips()
      }
    },
  },
  created() {
    window.addEventListener('keydown', this.handleKeyDown) //will attach the event listener to the whole window when the component is created
  },
  destroyed() {
    window.removeEventListener('keydown', this.handleKeyDown) //will detach the event listener once the component is destroyed
  },
  filters: {
    periodicity: function (value) {
      switch (value) {
        case 'SINGLE':
          return 'Solo una vez'
        case 'DAILY':
          return 'Diario'
        case 'WEEKLY':
          return 'Semanal'
        case 'MONTHLY':
          return 'Mensual'
      }
    },
  },
  computed: {},
}
</script>

<style></style>
